import { useEffect } from "react";

/**
 * Appends a `<script>` tag to the end of the document `<body>`.
 *
 * @param url The URL of the script.
 */
const useScript = (url: string) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default useScript;
